import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import HeaderInfo from '../HeaderInfo/HeaderInfo';
import styles from './ProductAvailability.module.scss';
import Models from '../../siteplanManagement/siteplanSection/models/Models';
import Lots from '../../siteplanManagement/siteplanSection/lots/Lots';
import NextButton from '../NextButton/NextButton';
import BackButton from '../BackButton/BackButton';
import { connect } from 'react-redux';
import {
	getAgreementDataById,
	nextActiveStep,
	saveAgreementInfo,
} from '../../../redux/agreement/actions';
import { useParams } from 'react-router';
import setLotToAvailable from '../../../api/Agreement/setLotToAvailable.api';
import setLotToPending from '../../../api/Agreement/setLotToPending.api';
import { setAlert } from '../../../redux/alerts/action';

const ProductAvailability = ({
	productAvailityData,
	saveAgreementInfo,
	loadedData,
	getAgreementDataById,
	setAlert,
	nextActiveStep,
}) => {
	const params = useParams();
	const [stayHighlighted, setStayHighlighted] = useState(true);
	useEffect(() => {
		console.log('loadedData product availability:', productAvailityData);
	}, [productAvailityData]);
	const handleSaveProductInfo = async () => {
		var isReturned = false;
		if (loadedData?.lotId) {
			await setLotToAvailable(loadedData?.lotId).then((returned) => {
				if (returned === true) {
					setAlert('warning', 'The lot has already been updated.');
					isReturned = true;
				}
			});
			await setLotToPending(productAvailityData?.lotId).then(
				(returned) => {
					if (returned === true) {
						setAlert(
							'warning',
							'The lot has already been updated.'
						);
						isReturned = true;
					}
				}
			);
		} else {
			await setLotToPending(productAvailityData?.lotId).then(
				(returned) => {
					if (returned === true) {
						setAlert(
							'warning',
							'The lot has already been updated.'
						);
						isReturned = true;
					}
				}
			);
		}

		if (isReturned === true) {
			return;
		} else {
			if (productAvailityData) {
				handleSaveAndExit();
				nextActiveStep();
			}
			// if (productAvailityData) {
			// 	saveAgreementInfo(
			// 		params.id,
			// 		'productAvailability',
			// 		productAvailityData
			// 	);
			// 	saveAgreementInfo(params.id, 'totalOptions', '0');
			// 	saveAgreementInfo(params.id, 'options', {});
			// }
			getAgreementDataById(params.id);
		}
	};
	const handleSaveAndExit = () => {
		saveAgreementInfo(
			params.id,
			'productAvailability',
			productAvailityData
		);
		saveAgreementInfo(params.id, 'totalOptions', '0');
		saveAgreementInfo(params.id, 'options', {});
	};
	return (
		<div className={styles.productAvailabilityWrapper}>
			<HeaderInfo
				title={'Product Availability'}
				onSaveAndExit={handleSaveAndExit}
			/>
			{/* <hr className={styles.headerSeparator} /> */}

			<div className={styles.siteplan_content}>
				<Grid container spacing={2}>
					<Grid
						item
						xs={4}
						// style={{ height: '100v', overflow: 'auto' }}
					>
						<Models
							loadedData={loadedData}
							setStayHighlighted={setStayHighlighted}
						/>
					</Grid>
					<Grid item xs={8}>
						<Lots stayHighlighted={stayHighlighted} />
					</Grid>
					<Grid item xs={4}>
						<div className={styles.backButtonWrapper}>
							<BackButton />
						</div>
					</Grid>
					<Grid item xs={8}>
						<div
							className={styles.nextButtonWrapper}
							onClick={() => {
								productAvailityData.lotId !== undefined &&
									handleSaveProductInfo();
							}}
						>
							<NextButton
								disabled={
									productAvailityData.lotId === undefined &&
									true
								}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	productAvailityData: state.siteplanManagement.lotWithModelSelected,
	loadedData: state.agreement?.agreementById?.productAvailability,
});

export default connect(mapStateToProps, {
	saveAgreementInfo,
	getAgreementDataById,
	setAlert,
	nextActiveStep,
})(ProductAvailability);
